<template>
  <aside class="poly-search fill-height">
    <v-layout column wrap fill-height>
      <v-flex class="poly-search__toolbar">
        <v-toolbar dense dark color="grey darken-3">
          <v-avatar color="primary" size="30">
            <v-icon small dark>add_circle</v-icon>
          </v-avatar>
          <v-toolbar-title>Add Models</v-toolbar-title>
          <v-spacer />
          <div class="poly-search__input">
            <v-layout row wrap align-center>
              <v-flex>
                <input type="text" v-model="searchTerm" placeholder="Search">
              </v-flex>
              <v-flex>
                <v-icon>search</v-icon>
              </v-flex>
            </v-layout>
          </div>
        </v-toolbar>
      </v-flex>
      <v-flex class="poly-search__results grey darken-4">
        <v-container fluid pa-0>
          <v-layout row wrap>
            <v-flex
              v-for="result in results"
              :key="result.name"
              xs4
              sm3
              md2
              d-flex
            >
              <poly-search-result :result="result" @selected="addObject"/>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-btn class="load-more" dark color="deep-orange" block v-if="nextPageToken" @click="nextPage" :loading="loading">Load more</v-btn>
    </v-layout>
  </aside>
</template>

<script>
import axios from 'axios'
import debounce from 'debounce'

import PolySearchResult from '@/components/poly/PolySearchResult'

export default {
  name: 'PolySearch',
  components: {
    PolySearchResult
  },
  data () {
    return {
      searchTerm: 'Cats',
      results: [],
      open: false,
      nextPageToken: null,
      loading: false
    }
  },
  created () {
    this.search = debounce(this.search, 300)
    this.search()
  },
  methods: {
    search () {
      axios.get(`https://poly.googleapis.com/v1/assets?keywords=${this.searchTerm}&format=GLTF2&key=${process.env.VUE_APP_POLY_API_KEY}`)
        .then((res) => {
          this.results = res.data.assets
          this.nextPageToken = res.data.nextPageToken
        })
    },
    nextPage () {
      this.loading = true
      axios.get(`https://poly.googleapis.com/v1/assets?keywords=${this.searchTerm}&format=GLTF2&key=${process.env.VUE_APP_POLY_API_KEY}&pageToken=${this.nextPageToken}`)
        .then((res) => {
          this.results = [...this.results, ...res.data.assets]
          this.nextPageToken = res.data.nextPageToken
          this.loading = false
        })
    },
    addObject (polyObject) {
      console.log(polyObject)
      const gltf = polyObject.formats.find(format => format.formatType === 'GLTF2')
      if (gltf) {
        const node = {
          type: 'GLTF',
          name: polyObject.displayName,
          meta: {
            authorName: polyObject.authorName,
            name: polyObject.name,
            description: polyObject.description
          },
          url: gltf.root.url,
          size: {
            w: 1,
            h: 1,
            d: 1
          },
          position: {
            x: 1,
            y: 1,
            z: 1
          }
        }
        this.$store.commit('three/addNode', { node })
        return
      }

      const obj = polyObject.formats.find(format => format.formatType === 'OBJ')
      if (obj) {
        const node = {
          type: 'OBJ',
          url: obj.root.url,
          size: {
            w: 1,
            h: 1,
            d: 1
          },
          position: {
            x: 1,
            y: 1,
            z: 1
          }
        }
        this.$store.commit('three/addNode', { node })
      }
    }
  },
  watch: {
    searchTerm () {
      this.search()
    }
  }
}
</script>

<style scoped lang="scss">
.poly-search {
  min-height: 100%;
}

.poly-search__toolbar {
  position: relative;
  z-index: 10;
  flex: 0 1 auto;
}

.poly-search /deep/ .v-toolbar__content {
  padding-right: 5px;
  padding-top: 10px;
  padding-bottom: 10px;
}

input {
  outline: none;
}

.poly-search__input {
  background-color: rgba(255,255,255, 0.1);
  padding: 5px 10px;
  border-radius: 4px;
}

.poly-search__results  {
  position: relative;
  overflow: scroll;
}

.load-more {
  position: absolute;
  bottom: 10px;
  z-index: 100;
  width: 130px;
  right: 30px;
}
</style>
